import {
  getQuizzesUseCase,
  getSummaryUseCase,
  postSendQuestionsUseCase,
  postStartUseCase,
} from "./Admission/6_UseCases";
import {
  currentUserUseCase,
  logoutUserUseCase,
  validAuthenticationUseCase,
} from "./User/6_UseCases/factory";

const useCases = {
  get_quizzes_use_case: getQuizzesUseCase(),
  get_summary_use_case: getSummaryUseCase(),
  post_start_use_case: postStartUseCase(),
  post_send_questions_use_case: postSendQuestionsUseCase(),
  valid_authentication_use_case: validAuthenticationUseCase(),
  current_user_use_case: currentUserUseCase(),
  logout_use_case: logoutUserUseCase(),
};

export default useCases;
